(function(){
    angular.module('ui2.0Service')
        .service('delegationService', delegationService);
    function delegationService(){
        var self = this;
        this.selectedTab = {};
        this.allleftTabInfo={};
        this.selectedRoleGroupId = '';
        this.selectedCheckBoxes=[];
        this.delegationCreateDisabled = true;
    }
})();
